import { render } from "./AppHeader.vue?vue&type=template&id=7deaf31e"
const script = {}
script.render = render

export default script